import { OrderDirection } from '../../Datatable/OrderDirection';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
export default interface MyFixtureQueryModel {
    year: number,
    support: number,
    statuses: QueryItem[],
    bizTypes: QueryItem[],

    vesselNames: QueryItem[],
    brokers: QueryItem[],

    hasInvNo: string,
    receivedDateYear: number,
    hasEvaluation: string,

    showCloseFile: boolean,

    orderBy: string,
    orderDirection: OrderDirection,
}

export enum HasEnumValue {
    Yes = "Yes",
    No = "No",
    All = "All"
}

export enum HasEvaluationValue {
    All = "All",
    NoEva = "Blank",
    NoS = "PIC Evaluated",
    NoM = "Manager Evaluated",
    FullEva = "All Evaluated",
}